import { StrictMode } from 'react';
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { AppProvider } from './app/app-context';
import { MallangApp } from './app/App';
import './app/styles.css';

if (Capacitor.getPlatform() === 'android') {
  void CapacitorApp.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) window.history.back();
    else void CapacitorApp.exitApp();
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HashRouter>
      <AppProvider>
        <MallangApp />
      </AppProvider>
    </HashRouter>
  </StrictMode>,
);
